import { PharmacyContract } from '../models/pharmacy.contract.model';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { RoleService } from './role.service';

@Injectable({
  providedIn: 'root'
})
export class PharmacyContractService {

  model: PharmacyContract = null;
  modelSearch: PharmacyContract = null;

  list: PharmacyContract[];
  baseUrl: string;

  totalRecords: number;
  pageSize: number = 10;
  currentPage: number = 1;
  totalPages: number;
  pages: number[];

  pharmacyID: number;

  constructor(private roleService: RoleService, private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  post() {
    this.model.createdBy = this.roleService.getStaffID();
    this.model.pharmacyID = this.pharmacyID;
    return this.http.post(this.baseUrl + "api/PharmacyContract", this.model);
  }

  put() {
    this.model.modifiedBy = this.roleService.getStaffID();
    this.model.pharmacyID = this.pharmacyID;
    return this.http.put(this.baseUrl + "api/PharmacyContract/" + this.model.pharmacyContractID, this.model);
  }

  updateStatus(status) {
    this.model.status = status;
    return this.http.put(this.baseUrl + "api/PharmacyContract/UpdateStatus/" + this.model.pharmacyContractID, this.model);
  }

  delete(id) {
    return this.http.delete(this.baseUrl + "api/PharmacyContract/" + id);
  }

  archive(id) {
    return this.http.get(this.baseUrl + "api/PharmacyContract/Archive/" + id);
  }

  search() {
    let params = new HttpParams().set("page", this.currentPage.toString()).set("pageSize", this.pageSize.toString());

    params = params.set("pharmacyID", this.pharmacyID.toString());

    if (this.modelSearch.drugID != null)
      params = params.set("stateNameEn", this.modelSearch.drugID.toString());

    if (this.modelSearch.serviceCategoryID != null)
      params = params.set("serviceCategoryID", this.modelSearch.serviceCategoryID.toString());

    if (this.modelSearch.genericID != null)
      params = params.set("genericID", this.modelSearch.genericID.toString());

    this.http.get(this.baseUrl + "api/PharmacyContract/Search", { params: params })
      .toPromise()
      .then(res => this.loadData(res));
  }

  loadData(res) {
    this.list = res.item1 as PharmacyContract[];
    this.paginate(res.item2);
  }

  paginate(totalRecords) {

    var pageSize = this.pageSize;
    var currentPage = this.currentPage;
    // calculate total pages
    var totalPages = Math.ceil(totalRecords / pageSize);

    var startPage, endPage;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    // calculate start and end item indexes
    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, totalRecords - 1);

    this.totalPages = totalPages;
    this.totalRecords = totalRecords;

    // create an array of pages to ng-repeat in the pager control
    this.pages = [];
    var i;
    for (i = startPage; i <= endPage; i++)
      this.pages.push(i);
  };
}
